// packages/whiteboard/src/features/ellipse/ellipse-options.config.ts

import {
  FILL_ACTIONS,
  BORDER_ACTIONS,
  BORDER_WIDTH_ACTIONS,
  BORDER_STYLE_ACTIONS,
  BOX_SHADOW_ACTIONS,
  BACKGROUND_OPACITY_ACTIONS,
  Z_ORDER_ACTIONS,
  ALIGN_ACTIONS,
  BOARD_COMMAND_ACTIONS,
  type OptionsCircleDef,
} from '../../optionsbar/optionsbar-actions.js';
import { composeOptionsCircle } from '../../optionsbar/parts/compose-options-circle.js';

// Optionskreis aus Einzelteilen (Kreis = 1+2+3): Standard-Knöpfe +
// Rahmen/Linien-Optionen + Füllfarben.
const ellipseSvg = composeOptionsCircle([1, 2, 3]);

/**
 * Ellipse-specific optionsbar definition (PRD-F1 §T22). The slice owns the
 * SVG/action mapping for its own optionsbar circle. Composed ENTIRELY from
 * shared action maps — no ellipse-specific action code. Same set as the
 * rectangle MINUS border-radius (a circle has no corners); the intent →
 * property mapping lives in optionsbar-config's `resolveProperty`. Z-order and
 * board commands are object-type agnostic (handled by the optionsbar element).
 */
export const ELLIPSE_OPTIONS: OptionsCircleDef = {
  svg: ellipseSvg,
  actions: {
    ...FILL_ACTIONS,
    ...BORDER_ACTIONS,
    ...BORDER_WIDTH_ACTIONS,
    ...BORDER_STYLE_ACTIONS,
    ...BOX_SHADOW_ACTIONS,
    ...BACKGROUND_OPACITY_ACTIONS,
    ...Z_ORDER_ACTIONS,
    ...ALIGN_ACTIONS,
    ...BOARD_COMMAND_ACTIONS,
  },
};
